//
// Spin Controller
//
// ----------------------------
spinController = {};
spinController.mainSpinConfig = {};

spinController.mainLandConfig = {};

spinController.mainLandOffsets = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

spinController.mainSpinTimeOffsets = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

spinController.startSpin = function (reelsToSpin) {
  spinController.mainSpinConfig = {};

  spinController.mainLandConfig = {};

  gameController.mainReelAnticipationSoundStarted = false;

  const allReels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
  const reels = reelsToSpin ?? allReels;
  let reelsToHold = [];

  if (reelsToSpin) {
    reelsToHold = allReels.filter((reel) => !reelsToSpin.includes(reel));
  }

  for (let i = 0; i < 15; i++) {
    let shouldSpin = reels.find((element) => element === i);

    if (shouldSpin !== undefined) {
      shouldSpin = true;
    }

    const mainReelStartOffset = 0.05 * i;
    const mainReelSpinOffset = i === 7 ? 0.05 * i + 1.1 : 0.05 * i;

    let mainSpin = 0.8;
    if (gameData.license === "DE") {
      mainSpin = 4;
    }

    const mainReel = {
      type: "main",
      startDelay: 0.1,
      reelStartDelayOffset: mainReelStartOffset,
      pullbackAmount: 0.4,
      pullbackTime: 0.2,
      pullbackStrength: 3.0,
      accelerationTime: 0.15,
      accelerationStrength: 2.0,
      symbolsPerSecond: 18,
      mainReelSpinTime: mainSpin,
      mainReelSpinTimeReelOffset: mainReelSpinOffset,
      decelerationTime: 0.3,
      decelerationStrength: 3.0,
      bounceAmount: 20,
      bounceTime: 0.25,
    };
    const mainReelSpinOffsets = mainReelStartOffset + mainReelSpinOffset;

    spinController.mainSpinTimeOffsets[i] = mainReelSpinOffsets;
    spinController.mainSpinConfig[`reel${i}`] = mainReel;
  }

  gameController.slotMachine.holdReels(reelsToHold);
  for (let i = 0; i < reelsToHold.length; i++) {
    const reelName = "reel" + reelsToHold[i];
    spinController.mainSpinConfig[reelName] = undefined;
  }
  gameController.slotMachine.dynamicSpin(spinController.mainSpinConfig);
};

spinController.stopSpin = function (symbols, above, below, mainSpinCompleteCallback, nudgeModifier) {
  spinController.setupLandConfigs();

  // if we're nudging set the symbol that should actually land in the middle
  let stopSymbols = symbols;
  if (nudgeModifier && nudgeModifier.isAwarded) {
    stopSymbols = symbols.map((inner) => [...inner]);
    const middleSymbolIndex = 7;

    const aboveBelowSmb =
      nudgeModifier.nudgeSymbols.length === 1 ? stopSymbols[middleSymbolIndex][0] : nudgeModifier.nudgeSymbols[1];

    if (nudgeModifier.isUpNudge) {
      below[7].push(aboveBelowSmb);
      above[7].push(1);
    } else {
      above[7].push(aboveBelowSmb);
      below[7].push(1);
    }

    stopSymbols[middleSymbolIndex] = [nudgeModifier.nudgeSymbols[0]];
  } else {
    const center = symbols[7][0];
    if (center === 16 || center === 17 || center === 18 || center === 19) {
      const aboveRan = Math.floor(Math.random() * 16);
      const belowRan = Math.floor(Math.random() * 16);

      above[7].push(aboveRan);
      below[7].push(belowRan);
    }
  }

  gameController.slotMachine.stopReels(
    stopSymbols,
    above,
    below,
    mainSpinCompleteCallback,
    spinController.mainLandConfig
  );
};

spinController.startLongSpinEffects = function () {
  for (let reel = 0; reel < gameController.convertedReelResults.length; reel++) {
    gameData.reels[reel].startSlowDown();
  }

  timerManager.addTimeout(7500, function () {
    for (let reel = 0; reel < gameController.convertedReelResults.length; reel++) {
      gameData.reels[reel].stopSlowDown();
    }
  });
};

spinController.setupLandConfigs = function () {
  let reels = [];

  if (!spinController.longSpinMainReels) {
    spinController.longSpinMainReels = Array(15).fill(false);
  }

  for (let i = 0; i < spinController.longSpinMainReels.length; i++) {
    if (spinController.longSpinMainReels[i]) {
      reels.push(i);
    }
  }

  const decelTime = 2.8;

  let spinExtension = 0;
  if (gameController.canFirewave) {
    spinExtension = 4;
  }

  for (let i = 0; i < spinController.longSpinMainReels.length; i++) {
    let mainReel = {
      type: "main",
      mainReelSpinExtension: spinExtension,
    };
    spinController.mainLandConfig[`reel${i}`] = mainReel;
  }

  for (let i = 0; i < reels.length; i++) {
    const reel = reels[i];

    let mainReel = {
      type: "main",
      mainReelSpinExtension: spinExtension,
      decelerationTime: decelTime,
      decelerationStrength: 3,
      bounceAmount: 0,
      bounceTime: 0,
    };
    spinController.mainLandConfig[`reel${reel}`] = mainReel;
  }
};
